__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-template-manager/v4_2_12/";